import React from 'react';
import { CustomersTypologiesChart } from '../../../../../entity/charts/typologies';
import { Typologies } from './lawyerSnippet.types';

type Props = {
  typologies: Typologies;
};

export function TypologiesTab(props: Props) {
  return (
    <div className="enterprise-snippet__panel">
      <CustomersTypologiesChart
        typologiesLabels={props.typologies.labels}
        typologiesData={props.typologies.datas}
      />
    </div>
  );
}
